module.exports = __webpack_public_path__ + "img/proyecto4.6d30655f.png";